export default "__VITE_ASSET__tZSOt$pw__"